import { apis } from '@/config';
import { api } from '@/api/api';
import { colors, contactCustomerDBName, contactCustomerGlobalDBName, contactDbName, contactItemTable, contactItemTableHitList, contactSearchDbName, contactTable, contactTableHitList, CustomerContactSearchHitList, edmcontactSearchDbName, frequentContactTable, orgContactTable, orgManager, orgpathlistTable, orgTable, orgTableHitList, personalMarkTable, recentContactTable, searchTableLimit, lxInfoTable, StaticNodeKey, statusLevel, searchResultDisplayLimit, LOCAL_ENTERPRISE_SKIP_THRESHOLD, } from './const';
import { getAccountSession as syncGetAccountSession, getContactSyncIntervalSeq as syncGetContactSyncIntervalSeq, getStoreContactSyncPageInfo as syncGetStoreContactSyncPageInfo, getStoreLastTime as syncGetStoreLastTime, retry as syncRetry, setContactSyncIntervalSeq as syncSetContactSyncIntervalSeq, setStoreContactSyncPageInfo as syncSetStoreContactSyncPageInfo, setStoreLastTime as syncSetStoreLastTime, } from './sync';
import { getValidContact as validationGetValidContact, getValidEmail as validationGetValidEmail, getValidModel as validationGetValidModel, filterNotDisplayEmailSearchRes as validationFilterNotDisplayEmailSearchRes, } from './validation';
import { getCustomerRole as roleGetCustomerRole, getCustomerRoleByMangerIds as roleGetCustomerRoleByMangerIds } from './customer_role';
import { forbiddenBridgeOnce as eventForbiddenBridgeOnce, sendCrossEvent as eventSendCrossEvent } from './event';
import { computeEntityOrgMemberCount as orgComputeEntityOrgMemberCount, handleAccountAndDomain as orgHandleAccountAndDomain } from './org';
import { catchError as commonCatchError, contactLog as commonContactLog, doGetModelDisplayEmail as commonDoGetModelDisplayEmail, findContactInfoVal as commonFindContactInfoVal, getCurrentAccount as commonGetCurrentAccount, getCurrentCompanyId as commonGetCurrentCompanyId, getCurrentContactId as commonGetCurrentContactId, getDomain as commonGetDomain, getEmail as commonGetEmail, getPublicParamFromMultipleOptions as commonGetPublicParamFromMultipleOptions, logger as commonLogger, transContactModel2ContactItem as commonTransContactModel2ContactItem, useTime as commonUseTime, } from './common';
export class ContactConst {
    constructor() {
        this.dbApi = api.requireLogicalApi(apis.dbInterfaceApiImpl);
        this.httpApi = api.getDataTransApi();
        this.systemApi = api.getSystemApi();
        this.taskApi = api.requireLogicalApi(apis.taskApiImpl);
        this.eventApi = api.getEventApi();
        this.store = api.getDataStoreApi();
        this.loggerApi = api.requireLogicalApi(apis.loggerApiImpl);
        this.accountApi = api.requireLogicalApi(apis.accountApiImpl);
        this.edmRoleApi = api.requireLogicalApi(apis.edmRoleApiImpl);
        this.contactDbName = contactDbName;
        this.contactSearchDbName = contactSearchDbName;
        this.edmcontactSearchDbName = edmcontactSearchDbName;
        this.contactCustomerGlobalDBName = contactCustomerGlobalDBName;
        this.contactCustomerDBName = contactCustomerDBName;
        this.contactTable = contactTable;
        this.contactItemTable = contactItemTable;
        this.orgContactTable = orgContactTable;
        this.orgManager = orgManager;
        this.orgTable = orgTable;
        this.recentContactTable = recentContactTable;
        this.personalMarkTable = personalMarkTable;
        this.orgpathlistTable = orgpathlistTable;
        this.frequentContactTable = frequentContactTable;
        this.lxInfoTable = lxInfoTable;
        this.orgTableHitList = orgTableHitList;
        this.contactTableHitList = contactTableHitList;
        this.CustomerContactSearchHitList = CustomerContactSearchHitList;
        this.contactItemTableHitList = contactItemTableHitList;
        this.colors = colors;
        this.StaticNodeKey = StaticNodeKey;
        this.searchTableLimit = searchTableLimit;
        this.searchResultDisplayLimit = searchResultDisplayLimit;
        this.LOCAL_ENTERPRISE_SKIP_THRESHOLD = LOCAL_ENTERPRISE_SKIP_THRESHOLD;
        this.statusLevel = statusLevel;
    }
    handleAccountAndDomain(account) {
        return orgHandleAccountAndDomain(account, { systemApi: this.systemApi });
    }
    setContactSyncIntervalSeq(minutes) {
        syncSetContactSyncIntervalSeq(minutes);
    }
    getContactSyncIntervalSeq() {
        return syncGetContactSyncIntervalSeq();
    }
    getDomain() {
        return commonGetDomain(this.systemApi);
    }
    getCurrentAccount() {
        return commonGetCurrentAccount(this.systemApi);
    }
    getEmail() {
        return commonGetEmail(this.systemApi);
    }
    getCurrentContactId() {
        return commonGetCurrentContactId(this.systemApi);
    }
    getCurrentCompanyId(email) {
        return commonGetCurrentCompanyId(this.systemApi, email);
    }
    useTime(start) {
        return commonUseTime(start);
    }
    async getStoreLastTime(lastTimeKey) {
        return syncGetStoreLastTime(lastTimeKey, { store: this.store, taskApi: this.taskApi, systemApi: this.systemApi, accountApi: this.accountApi });
    }
    setStoreLastTime(lastTimeKey, lastTime) {
        return syncSetStoreLastTime(lastTimeKey, lastTime, { store: this.store, taskApi: this.taskApi, systemApi: this.systemApi, accountApi: this.accountApi });
    }
    async getStoreContactSyncPageInfo(params) {
        return syncGetStoreContactSyncPageInfo(params, { store: this.store, taskApi: this.taskApi, systemApi: this.systemApi, accountApi: this.accountApi });
    }
    async setStoreContactSyncPageInfo(params, enableUseNewestTime = true) {
        return syncSetStoreContactSyncPageInfo(params, enableUseNewestTime, {
            store: this.store,
            taskApi: this.taskApi,
            systemApi: this.systemApi,
            accountApi: this.accountApi,
        });
    }
    getAccountSession(_account) {
        return syncGetAccountSession(_account, { store: this.store, taskApi: this.taskApi, systemApi: this.systemApi, accountApi: this.accountApi });
    }
    async retry(fn, count = 3) {
        return syncRetry(fn, count);
    }
    getValidModel(_pre, _cur) {
        return validationGetValidModel(_pre, _cur);
    }
    getValidContact(pre, cur) {
        return validationGetValidContact(pre, cur);
    }
    filterNotDisplayEmailSearchRes(list) {
        return validationFilterNotDisplayEmailSearchRes(list);
    }
    contactLog(key, data) {
        return commonContactLog(key, this.loggerApi, data);
    }
    logger(key, data) {
        return commonLogger(key, this.loggerApi, data);
    }
    catchError(reason) {
        return commonCatchError(reason);
    }
    doGetModelDisplayEmail(model) {
        return commonDoGetModelDisplayEmail(model);
    }
    transContactModel2ContactItem(item) {
        return commonTransContactModel2ContactItem(item);
    }
    getValidEmail(_pre, _cur, isMainAccount = true) {
        return validationGetValidEmail(_pre, _cur, isMainAccount);
    }
    getCustomerRole(params) {
        return roleGetCustomerRole(params);
    }
    getCustomerRoleByMangerIds(params) {
        return roleGetCustomerRoleByMangerIds(params);
    }
    forbiddenBridgeOnce() {
        return eventForbiddenBridgeOnce();
    }
    findContactInfoVal(contactInfoList, type = 'EMAIL') {
        return commonFindContactInfoVal(contactInfoList, type);
    }
    async sendCrossEvent(data, options) {
        return eventSendCrossEvent(data, { eventApi: this.eventApi }, options);
    }
    async computeEntityOrgMemberCount(options) {
        return orgComputeEntityOrgMemberCount(options);
    }
    getPublicParamFromMultipleOptions(options) {
        return commonGetPublicParamFromMultipleOptions(options);
    }
}
export default new ContactConst();
